import sassVariables from '@/styles/variables.scss'

const platform = () => {
  const _ua = navigator.userAgent
  let platform = ''
  let browser = ''

  if (_ua.match(/iPad|iPhone|iPod/) && !window.MSStream) {
    platform = 'ios'
  } else if (_ua.match(/MSIE |Trident\/|Edge\//)) {
    platform = 'ie'
  } else if (_ua.match(/Android /)) {
    platform = 'android'
  }

  if (_ua.match(/Safari/)) {
    if (_ua.match(/Chrome/)) {
      browser = 'chrome'
    } else {
      browser = 'safari'
    }
  }

  !!platform && document.body.classList.add(`is-${platform}`)

  return {
    platform,
    browser
  }
}

const normalizePxUnits = value => value.replace('px', '').concat('px')

const watchMaxWidth = (width, callback) => {
  if (typeof width === 'undefined' || typeof callback !== 'function') {
    return null
  }

  let mediaQuery = window.matchMedia(`(max-width: ${normalizePxUnits(width)})`)
  mediaQuery.addListener(callback)

  return () => mediaQuery.removeListener(callback)
}

const maxWidth = width => {
  return window.matchMedia(`(max-width: ${normalizePxUnits(width)})`).matches
}

const iosScrollFix = element => {
  if (!element || !element.tagName) {
    throw new ReferenceError('Invalid argument. DOM node element expected.')
  }

  if (!element.iosScrollFixed) {
    element.iosScrollFixed = true
    element.addEventListener('touchstart', function (event) {
      this.aup = (this.scrollTop > 0)
      this.ud = (this.scrollTop < this.scrollHeight - this.clientHeight)
      this.lastY = event.pageY
    })
    element.addEventListener('touchmove', function (event) {
      const up = (event.pageY > this.lastY)
      this.lastY = event.pageY

      if ((up && this.aup) || (!up && this.ud)) {
        event.stopPropagation()
      } else {
        event.preventDefault()
      }
    })
  }
}

const detectPlatform = () => {
  const _ua = navigator.userAgent
  let platform = ''

  if (_ua.match(/iPad|iPhone|iPod/) && !window.MSStream) {
    platform = 'ios'
  } else if (_ua.match(/MSIE |Trident\/|Edge\//)) {
    platform = 'ie'
  } else if (_ua.match(/Android /)) {
    platform = 'android'
  }

  platform.length > 0 && document.body.classList.add(`is-${platform}`)
  return platform
}

export { platform, maxWidth, watchMaxWidth, iosScrollFix, sassVariables, detectPlatform }
